import type { Vacancy } from '../types';

/**
 * Toon de tab «Clientportaal» op de vacature als minstens één gekoppelde organisatie
 * het klantportaal niet expliciet heeft uitgeschakeld (`active_clientportal === false`).
 * Ontbrekende join-data: tab tonen (backwards compatible).
 */
export function vacancyShowsClientPortalTab(v: Vacancy | null | undefined): boolean {
  if (!v) return false;
  const any = v as Record<string, unknown>;
  const orgs = [any.eindklant, any.opdrachtgever, any.client].filter(Boolean) as { active_clientportal?: boolean }[];
  if (!orgs.length) return true;
  return orgs.some((c) => c.active_clientportal !== false);
}
